import { initializeApp } from 'firebase/app'
import {
  connectFirestoreEmulator,
  initializeFirestore,
} from 'firebase/firestore'

import firebaseConfig, { getFirebaseLocalHost } from './firebaseConfig'

const app = initializeApp(firebaseConfig)

const firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
})

const { firebasePort, firebaseIp } = getFirebaseLocalHost()

if (firebasePort && firebaseIp) {
  connectFirestoreEmulator(
    firestore,
    firebaseIp || 'localhost',
    Number(firebasePort)
  )
}

export default firestore
